/* eslint-disable max-len */

import PropTypes from 'prop-types'

import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} satelliteDataConsumptionPropType
 * @property {Id} 					    unitId		        - The id of the unit.
 * @property {Id}                       objectId            - The ID of the object.
 * @property {number}				    remainingQuota		- The remaining quota (in kb).
 * @property {number}				    totalQuota		   	- The total quota (in kb).
 * @property {string}				    remainingDuration	- The estimated remaining ISO8601 duration.
 * @property {ISO8601} 				    suspended			- The data of suspension (ISO8601).
 * @property {bool} 	                warningThreshold	- The indication of max quota soon to be reached.
 */

export const satelliteDataConsumptionPropType = PropTypes.shape({
    unitId: idPropType,
    objectId: PropTypes.string.isRequired,
    remainingQuota: PropTypes.number,
    totalQuota: PropTypes.number,
    remainingDuration: PropTypes.string,
    suspended: iso8601PropType,
    warningThreshold: PropTypes.bool
})
